import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material';

import {
  IcecontrolSettings,
  IcemattableSettings,
  IcepanelgroupSettings,
  IcepanelsectionSettings,
  IcepanelSettings,
  IcepanelcontainerRowSettings,
  IcepanelcontainerSettings,

  iceColumnDefinition
} from '../../../../icemedx-lib/src/components/models/icesettings';

import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';

import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';
import { ReportService, IReportListItem, ReportListObject } from 'projects/icemedx-lib/src/services/report/report.service';
import { ScheduleService } from 'projects/icemedx-lib/src/services/schedule/schedule.service';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { reportindex } from 'projects/icemedx-lib/src/models/reports/reportindex';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
  providers: [IceNavService, AppService]
})
export class ReportsComponent implements OnInit {
  // data members
  dataForReports: MatTableDataSource<IReportListItem> = new MatTableDataSource<IReportListItem>([]);

  // member settings
  reportListSettings: IcepanelcontainerSettings = null;
  btnNewReportSettings: IcecontrolSettings = new IcecontrolSettings("NewReportButton", { text: "Add Report", class: [], glyphClass: "fa-plus-circle" }, null, null);

  constructor(private appSvc: AppService,
    private navSvc: IceNavService,
    private router: Router,
    private rptService: ReportService,
    private changeDetectorRefs: ChangeDetectorRef) {
    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Reports", {}, true, "");
  }

  ngOnInit() {
    this.appSvc.refreshMenus();

    let panelTag = "ReportList";
    let panelKey = Iceutility.guid(false);
    let tables: IcemattableSettings[] = [
      new IcemattableSettings("ReportTable",[
        new iceColumnDefinition("name", "Name", false),
        new iceColumnDefinition("report_key", "", true, true),
        new iceColumnDefinition("type", "Type", false),
        new iceColumnDefinition("run_frequency", "Run Frequency", false),
        new iceColumnDefinition("description", "Description", false),
        new iceColumnDefinition("source", "Source", false),
        new iceColumnDefinition("modified", "Modified", false),
        new iceColumnDefinition("modified_by", "Modified By", false),
      ],

      this.dataForReports, null, true)
    ];
    let groups: IcepanelgroupSettings[] = [
      new IcepanelgroupSettings(null, tables)
    ];

    let sections: IcepanelsectionSettings[] = [
      new IcepanelsectionSettings("ReportListSection", { class: ["yalla"], styles: { width: "100%" } }, groups, null, null)
    ];
    let panels: IcepanelSettings[] = [
      new IcepanelSettings(panelTag, panelKey, "Reports", "", sections)];

    let panelrows: IcepanelcontainerRowSettings[] = [new IcepanelcontainerRowSettings(panels)];
    this.reportListSettings = new IcepanelcontainerSettings("ReportListContainer", panelrows);

    let api = "";
    let acttype = this.appSvc.getCurrentAccountType();
    switch (acttype) {
      case IceTypes.ACCOUNT_TYPE.actFacility:
      case IceTypes.ACCOUNT_TYPE.actProvider:
        api = "providers";
        break;
      case IceTypes.ACCOUNT_TYPE.actPharmacy:
        api = "pharmacies";
        break;
      case IceTypes.ACCOUNT_TYPE.actPayer:
        api = "payers";
        break;
      default:
        this.rptService.logMessage(IceTypes.LOGTYPE.ltError, "Error reporting API not supported. ");
        return;
    }

    this.rptService.getReports(api, this.appSvc.getCurrentAccount(), acttype).subscribe(
      data => {
        if (data == null) return;

        let dat: ReportListObject[] = [];
        for (let i = 0; i < data.length; i++) {
          let repidx: reportindex = <reportindex>data[i];
          if (repidx == null) continue;

          dat.push(new ReportListObject(
            repidx.report_key,
            repidx.rpt_name,
            ReportService.getReportType(repidx.report_type),
            ScheduleService.getRecurringType(repidx.recurring_type),
            repidx.rpt_desc,
            ReportService.getReportType(repidx.src_type),
            Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(repidx.modified)),
            repidx.modified_user))
        }

        this.dataForReports.data = dat;
      },
      error => {
        console.log(JSON.stringify(this.rptService.getLastErrors()));
      });
    this.changeDetectorRefs.detectChanges();
  }

  onNewReport(event) {
    this.router.navigate([this.navSvc.buildRoute("report/0", false)]);
  }

  onMatGridRowClick(event) {
    if (event.rowData == null) {
      // To do log error
      return;
    }
    this.router.navigate([this.navSvc.buildRoute("viewreport/" + event.rowData.report_key, false)]);
  }
}
